import { SmallError } from '../../icons/SmallError';
import { makeStyles, Typography} from '@material-ui/core';
import MUISnackbar from '@material-ui/core/Snackbar';
import {PrimaryButton} from "../common/PrimaryButton";

const useStyles = makeStyles({
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '400px',
    minHeight: '50px',
    background: 'white',
    padding: '1em',
    borderRadius: '3px',
    boxShadow: '0 12px 24px 4px rgba(40,42,43,0.2)',
    borderLeft: '4px solid #f44349',
  },
  contentContainer: {
    display: 'flex',
    lineHeight: 1.8,
  },
  iconContainer: {
    display: 'flex',
    padding: '0 1.3em 0 0.3em',
    transform: 'translateY(3px)',
  },
  headline: {
    fontWeight: 'bold',
  },
});

interface SnackbarProps {
  open: boolean;
}

export function Snackbar({ open }: SnackbarProps) {
  const classes = useStyles();

  return (
    <MUISnackbar
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={open}
      autoHideDuration={110000}
    >
      <div className={classes.container}>
        <div className={classes.contentContainer}>
          <div className={classes.iconContainer}>
            <SmallError />
          </div>
          <div>
            <Typography variant="body1" className={classes.headline}>
              Device change: unable to connect -
            </Typography>
            <Typography variant="body1">
              {' '}
              please reset your browser/OS permissions (which may be in your "Settings") and refresh this page.
            </Typography>
            <PrimaryButton
                    style={{ marginTop: '1em', borderRadius: '6px'}} onClick={() => window.location.reload()}>
              Refresh page
            </PrimaryButton>
          </div>
        </div>
      </div>
    </MUISnackbar>
  );
}
